"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EnumBase = /** @class */ (function () {
    function EnumBase(name, id) {
        this.name = name;
        this.id = id;
    }
    return EnumBase;
}());
exports.EnumBase = EnumBase;
var AccessType = /** @class */ (function (_super) {
    __extends(AccessType, _super);
    function AccessType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AccessType.GetAll = function () {
        var all = [AccessType.Public, AccessType.Private];
        return all;
    };
    AccessType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AccessType.Public = new AccessType("Public", "Public");
    AccessType.Private = new AccessType("Private", "Private");
    AccessType.Unknown = new AccessType("Unknown Access Type ", "UnknownAccessType ");
    return AccessType;
}(EnumBase));
exports.AccessType = AccessType;
var AssignableProductType = /** @class */ (function (_super) {
    __extends(AssignableProductType, _super);
    function AssignableProductType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AssignableProductType.GetAll = function () {
        var all = [AssignableProductType.WorkType, AssignableProductType.ProductDefinition, AssignableProductType.UnAssignedWork, AssignableProductType.Contract];
        return all;
    };
    AssignableProductType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AssignableProductType.WorkType = new AssignableProductType("Work Type", "WorkType");
    AssignableProductType.ProductDefinition = new AssignableProductType("Product Definition", "ProductDefinition");
    AssignableProductType.Contract = new AssignableProductType("Contract", "Contract");
    AssignableProductType.UnAssignedWork = new AssignableProductType("UnAssignedWork", "UnAssignedWork");
    AssignableProductType.Unknown = new AssignableProductType("Unknown Assignable Product Type", "UnknownAssignableProductType");
    return AssignableProductType;
}(EnumBase));
exports.AssignableProductType = AssignableProductType;
var CreateDeliverableOptions = /** @class */ (function (_super) {
    __extends(CreateDeliverableOptions, _super);
    function CreateDeliverableOptions(name, id) {
        return _super.call(this, name, id) || this;
    }
    CreateDeliverableOptions.GetAll = function () {
        var all = [CreateDeliverableOptions.FullDeliverable, CreateDeliverableOptions.PartialDeliverable, CreateDeliverableOptions.PartialWithProductDeliverable];
        return all;
    };
    CreateDeliverableOptions.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    CreateDeliverableOptions.FullDeliverable = new CreateDeliverableOptions("Full Deliverable", "FullDeliverable");
    CreateDeliverableOptions.PartialDeliverable = new CreateDeliverableOptions("Partial Deliverable", "PartialDeliverable");
    CreateDeliverableOptions.PartialWithProductDeliverable = new CreateDeliverableOptions("Partial With Product Deliverable", "PartialWithProductDeliverable");
    CreateDeliverableOptions.Unknown = new CreateDeliverableOptions("Unknown Create Deliverable Option", "UnknownCreateDeliverableOption");
    return CreateDeliverableOptions;
}(EnumBase));
exports.CreateDeliverableOptions = CreateDeliverableOptions;
var CriteriaCollection = /** @class */ (function (_super) {
    __extends(CriteriaCollection, _super);
    function CriteriaCollection(name, id) {
        return _super.call(this, name, id) || this;
    }
    CriteriaCollection.GetAll = function () {
        var all = [CriteriaCollection.Deliverables, CriteriaCollection.ProductInstances, CriteriaCollection.WorkTypes, CriteriaCollection.ProductDefinitions];
        return all;
    };
    CriteriaCollection.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    CriteriaCollection.Deliverables = new CriteriaCollection("Deliverables", "Deliverables");
    CriteriaCollection.ProductInstances = new CriteriaCollection("Product Instances", "ProductInstances");
    CriteriaCollection.WorkTypes = new CriteriaCollection("Work Types", "WorkTypes");
    CriteriaCollection.ProductDefinitions = new CriteriaCollection("Product Definitions", "ProductDefinitions");
    CriteriaCollection.Unknown = new CriteriaCollection("Unknown Criteria Collection", "UnknownCriteriaCollection");
    return CriteriaCollection;
}(EnumBase));
exports.CriteriaCollection = CriteriaCollection;
var CriteriaTarget = /** @class */ (function (_super) {
    __extends(CriteriaTarget, _super);
    function CriteriaTarget(name, id) {
        return _super.call(this, name, id) || this;
    }
    CriteriaTarget.GetAll = function () {
        var all = [CriteriaTarget.CurrentDeliverable, CriteriaTarget.ImmediateChildren, CriteriaTarget.ImmediateParent, CriteriaTarget.AnyDescendant, CriteriaTarget.AnyAncestor];
        return all;
    };
    CriteriaTarget.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    CriteriaTarget.CurrentDeliverable = new CriteriaTarget("Current Deliverable", "CurrentDeliverable");
    CriteriaTarget.ImmediateChildren = new CriteriaTarget("Immediate Children", "ImmediateChildren");
    CriteriaTarget.ImmediateParent = new CriteriaTarget("Immediate Parent", "ImmediateParent");
    CriteriaTarget.AnyDescendant = new CriteriaTarget("Any Descendant", "AnyDescendant");
    CriteriaTarget.AnyAncestor = new CriteriaTarget("Any Ancestor", "AnyAncestor");
    CriteriaTarget.Unknown = new CriteriaTarget("Unknown Criteria Target", "UnknownCriteriaTarget");
    return CriteriaTarget;
}(EnumBase));
exports.CriteriaTarget = CriteriaTarget;
var CriteriaType = /** @class */ (function (_super) {
    __extends(CriteriaType, _super);
    function CriteriaType(name, id) {
        return _super.call(this, name, id) || this;
    }
    CriteriaType.GetAll = function () {
        var all = [CriteriaType.DirectCriteria, CriteriaType.DeliverableOrPhaseCriteria, CriteriaType.OwnerCriteria, CriteriaType.ParentCriteria];
        return all;
    };
    CriteriaType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    CriteriaType.DirectCriteria = new CriteriaType("Direct Criteria", "DirectCriteria");
    CriteriaType.DeliverableOrPhaseCriteria = new CriteriaType("Deliverable Or Phase Criteria", "DeliverableOrPhaseCriteria");
    CriteriaType.OwnerCriteria = new CriteriaType("Owner Criteria", "OwnerCriteria");
    CriteriaType.ParentCriteria = new CriteriaType("Parent Criteria", "ParentCriteria");
    CriteriaType.Unknown = new CriteriaType("Unknown Criteria Type", "UnknownCriteriaType");
    return CriteriaType;
}(EnumBase));
exports.CriteriaType = CriteriaType;
var DataStatusType = /** @class */ (function (_super) {
    __extends(DataStatusType, _super);
    function DataStatusType(name, id) {
        return _super.call(this, name, id) || this;
    }
    DataStatusType.GetAll = function () {
        var all = [DataStatusType.UnChanged, DataStatusType.Created, DataStatusType.Modified, DataStatusType.Deleted];
        return all;
    };
    DataStatusType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DataStatusType.UnChanged = new DataStatusType("Data is unchanged", "UnChanged");
    DataStatusType.Created = new DataStatusType("Data was created", "Created");
    DataStatusType.Modified = new DataStatusType("Data was modified", "Modified");
    DataStatusType.Deleted = new DataStatusType("Data was deleted", "Deleted");
    DataStatusType.Unknown = new DataStatusType("Unknown DataStatus Type", "UnknownDataStatusType");
    return DataStatusType;
}(EnumBase));
exports.DataStatusType = DataStatusType;
var DateRuleOperatorType = /** @class */ (function (_super) {
    __extends(DateRuleOperatorType, _super);
    function DateRuleOperatorType(name, id) {
        return _super.call(this, name, id) || this;
    }
    DateRuleOperatorType.GetAll = function () {
        var all = [DateRuleOperatorType.Minimum, DateRuleOperatorType.Maximum];
        return all;
    };
    DateRuleOperatorType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DateRuleOperatorType.Minimum = new DateRuleOperatorType("Minimum", "Minimum");
    DateRuleOperatorType.Maximum = new DateRuleOperatorType("Maximum", "Maximum");
    DateRuleOperatorType.Unknown = new DateRuleOperatorType("Unknown DateRuleOperatorType ", "UnknownDateRuleOperatorType ");
    return DateRuleOperatorType;
}(EnumBase));
exports.DateRuleOperatorType = DateRuleOperatorType;
var DeliverableFeature = /** @class */ (function (_super) {
    __extends(DeliverableFeature, _super);
    function DeliverableFeature(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliverableFeature.GetAll = function () {
        var all = [, DeliverableFeature.Product, DeliverableFeature.WorkType, DeliverableFeature.Outcomes, DeliverableFeature.Children, DeliverableFeature.Parent, DeliverableFeature.Placeholder, DeliverableFeature.Markable, DeliverableFeature.ReadOnly, DeliverableFeature.Editable, DeliverableFeature.Dependent, DeliverableFeature.Depender, DeliverableFeature.SubProduct];
        return all;
    };
    DeliverableFeature.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliverableFeature.Product = new DeliverableFeature("Product", "Product");
    DeliverableFeature.WorkType = new DeliverableFeature("WorkType", "WorkType");
    DeliverableFeature.Outcomes = new DeliverableFeature("Outcomes", "Outcomes");
    DeliverableFeature.Children = new DeliverableFeature("Children", "Children");
    DeliverableFeature.Parent = new DeliverableFeature("Parent", "Parent");
    DeliverableFeature.Placeholder = new DeliverableFeature("Placeholder", "Placeholder");
    DeliverableFeature.Markable = new DeliverableFeature("Markable", "Markable");
    DeliverableFeature.ReadOnly = new DeliverableFeature("ReadOnly", "ReadOnly");
    DeliverableFeature.Editable = new DeliverableFeature("Editable", "Editable");
    DeliverableFeature.Dependent = new DeliverableFeature("Dependent", "Dependent");
    DeliverableFeature.Depender = new DeliverableFeature("Depender", "Depender");
    DeliverableFeature.SubProduct = new DeliverableFeature("SubProduct", "SubProduct");
    DeliverableFeature.Unknown = new DeliverableFeature("Unknown Deliverable Feature", "UnknownDeliverableFeature");
    return DeliverableFeature;
}(EnumBase));
exports.DeliverableFeature = DeliverableFeature;
var DeliverableLoadOptions = /** @class */ (function (_super) {
    __extends(DeliverableLoadOptions, _super);
    function DeliverableLoadOptions(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliverableLoadOptions.GetAll = function () {
        var all = [DeliverableLoadOptions.SingleDeliverable, DeliverableLoadOptions.ImmediateChildren, DeliverableLoadOptions.AllDescendants, DeliverableLoadOptions.ImmediateParent, DeliverableLoadOptions.AllAncestors, DeliverableLoadOptions.FullTree];
        return all;
    };
    DeliverableLoadOptions.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliverableLoadOptions.SingleDeliverable = new DeliverableLoadOptions("Single Deliverable", "SingleDeliverable");
    DeliverableLoadOptions.ImmediateChildren = new DeliverableLoadOptions("Immediate Children", "ImmediateChildren");
    DeliverableLoadOptions.AllDescendants = new DeliverableLoadOptions("All Descendants", "AllDescendants");
    DeliverableLoadOptions.ImmediateParent = new DeliverableLoadOptions("Immediate Parent", "ImmediateParent");
    DeliverableLoadOptions.AllAncestors = new DeliverableLoadOptions("All Ancestors", "AllAncestors");
    DeliverableLoadOptions.FullTree = new DeliverableLoadOptions("Full Tree", "FullTree");
    DeliverableLoadOptions.Unknown = new DeliverableLoadOptions("Unknown Deliverable Load Options", "UnknownDeliverableLoadOptions");
    return DeliverableLoadOptions;
}(EnumBase));
exports.DeliverableLoadOptions = DeliverableLoadOptions;
var DeliverableOrPhaseCriteriaOption = /** @class */ (function (_super) {
    __extends(DeliverableOrPhaseCriteriaOption, _super);
    function DeliverableOrPhaseCriteriaOption(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliverableOrPhaseCriteriaOption.GetAll = function () {
        var all = [DeliverableOrPhaseCriteriaOption.DeliverableCriteria, DeliverableOrPhaseCriteriaOption.PhaseCriteria, DeliverableOrPhaseCriteriaOption.DeliverableOrPhaseCriteria];
        return all;
    };
    DeliverableOrPhaseCriteriaOption.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliverableOrPhaseCriteriaOption.DeliverableCriteria = new DeliverableOrPhaseCriteriaOption("Deliverable Criteria", "DeliverableCriteria");
    DeliverableOrPhaseCriteriaOption.PhaseCriteria = new DeliverableOrPhaseCriteriaOption("Phase Criteria", "PhaseCriteria");
    DeliverableOrPhaseCriteriaOption.DeliverableOrPhaseCriteria = new DeliverableOrPhaseCriteriaOption("Deliverable Or Phase Criteria", "DeliverableOrPhaseCriteria");
    DeliverableOrPhaseCriteriaOption.Unknown = new DeliverableOrPhaseCriteriaOption("Unknown Deliverable Or Phase CriteriaType", "UnknownDeliverableOrPhaseCriteriaType");
    return DeliverableOrPhaseCriteriaOption;
}(EnumBase));
exports.DeliverableOrPhaseCriteriaOption = DeliverableOrPhaseCriteriaOption;
var DeliverableType = /** @class */ (function (_super) {
    __extends(DeliverableType, _super);
    function DeliverableType(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliverableType.GetAll = function () {
        var all = [, DeliverableType.DeliverableTopReadOnly, DeliverableType.DeliverableProductHeadReadOnly, DeliverableType.DeliverableProductChildReadOnly, DeliverableType.DeliverableWorkTypeHeadReadOnly, DeliverableType.DeliverableWorkTypeChildReadOnly, DeliverableType.PlaceholderUnAssignedWorkReadOnly, DeliverableType.PlaceholderProductHeadReadOnly, DeliverableType.PlaceholderProductChildReadOnly, DeliverableType.PlaceholderWorkTypeHeadReadOnly, DeliverableType.PlaceholderWorkTypeChildReadOnly, DeliverableType.DeliverableTop, DeliverableType.DeliverableProductHead, DeliverableType.DeliverableProductChild, DeliverableType.DeliverableWorkTypeHead, DeliverableType.DeliverableWorkTypeChild, DeliverableType.PlaceholderUnAssignedWork, DeliverableType.PlaceholderProductHead, DeliverableType.PlaceholderProductChild, DeliverableType.PlaceholderWorkTypeHead, DeliverableType.PlaceholderWorkTypeChild];
        return all;
    };
    DeliverableType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliverableType.DeliverableTopReadOnly = new DeliverableType("Deliverable Top ReadOnly", "DeliverableTopReadOnly");
    DeliverableType.DeliverableProductHeadReadOnly = new DeliverableType("Deliverable Product Head ReadOnly", "DeliverableProductHeadReadOnly");
    DeliverableType.DeliverableProductChildReadOnly = new DeliverableType("Deliverable Product Child ReadOnly", "DeliverableProductChildReadOnly");
    DeliverableType.DeliverableWorkTypeHeadReadOnly = new DeliverableType("Deliverable WorkType Head ReadOnly", "DeliverableWorkTypeHeadReadOnly");
    DeliverableType.DeliverableWorkTypeChildReadOnly = new DeliverableType("Deliverable WorkType Child ReadOnly", "DeliverableWorkTypeChildReadOnly");
    DeliverableType.PlaceholderUnAssignedWorkReadOnly = new DeliverableType("Placeholder ReadOnly", "PlaceholderReadOnly");
    DeliverableType.PlaceholderProductHeadReadOnly = new DeliverableType("Placeholder Product Head ReadOnly", "PlaceholderProductHeadReadOnly");
    DeliverableType.PlaceholderProductChildReadOnly = new DeliverableType("Placeholder Product Child ReadOnly", "PlaceholderProductChildReadOnly");
    DeliverableType.PlaceholderWorkTypeHeadReadOnly = new DeliverableType("Placeholder WorkType Head ReadOnly", "PlaceholderWorkTypeHeadReadOnly");
    DeliverableType.PlaceholderWorkTypeChildReadOnly = new DeliverableType("Placeholder WorkType Child ReadOnly", "PlaceholderWorkTypeChildReadOnly");
    DeliverableType.DeliverableTop = new DeliverableType("DeliverableTop", "DeliverableTop");
    DeliverableType.DeliverableProductHead = new DeliverableType("Deliverable Product Head", "DeliverableProductHead");
    DeliverableType.DeliverableProductChild = new DeliverableType("Deliverable Product Child", "DeliverableProductChild");
    DeliverableType.DeliverableWorkTypeHead = new DeliverableType("Deliverable WorkType Head", "DeliverableWorkTypeHead");
    DeliverableType.DeliverableWorkTypeChild = new DeliverableType("Deliverable WorkType Child", "DeliverableWorkTypeChild");
    DeliverableType.PlaceholderUnAssignedWork = new DeliverableType("Placeholder", "Placeholder");
    DeliverableType.PlaceholderProductHead = new DeliverableType("Placeholder Product Head", "PlaceholderProductHead");
    DeliverableType.PlaceholderProductChild = new DeliverableType("Placeholder Product Child ", "PlaceholderProductChild");
    DeliverableType.PlaceholderWorkTypeHead = new DeliverableType("Placeholder WorkType Head", "PlaceholderWorkTypeHead");
    DeliverableType.PlaceholderWorkTypeChild = new DeliverableType("Placeholder WorkType Child", "PlaceholderWorkTypeChild");
    DeliverableType.Unknown = new DeliverableType("Unknown Deliverable Type", "UnknownDDeliverableType");
    return DeliverableType;
}(EnumBase));
exports.DeliverableType = DeliverableType;
var ExistenceType = /** @class */ (function (_super) {
    __extends(ExistenceType, _super);
    function ExistenceType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ExistenceType.GetAll = function () {
        var all = [ExistenceType.RealDeliverable, ExistenceType.PlaceholderDeliverable];
        return all;
    };
    ExistenceType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ExistenceType.RealDeliverable = new ExistenceType("Real", "Real");
    ExistenceType.PlaceholderDeliverable = new ExistenceType("Placeholder", "Placeholder");
    ExistenceType.Unknown = new ExistenceType("Unknown Existance Type", "UnknownExistanceType");
    return ExistenceType;
}(EnumBase));
exports.ExistenceType = ExistenceType;
var InstanceType = /** @class */ (function (_super) {
    __extends(InstanceType, _super);
    function InstanceType(name, id) {
        return _super.call(this, name, id) || this;
    }
    InstanceType.GetAll = function () {
        var all = [InstanceType.SingleInstance, InstanceType.MultiInstance];
        return all;
    };
    InstanceType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    InstanceType.SingleInstance = new InstanceType("Single Instance", "SingleInstance");
    InstanceType.MultiInstance = new InstanceType("Multi Instance", "MultiInstance");
    InstanceType.Unknown = new InstanceType("Unknown Instance Type", "UnknownInstanceType");
    return InstanceType;
}(EnumBase));
exports.InstanceType = InstanceType;
var ObjectType = /** @class */ (function (_super) {
    __extends(ObjectType, _super);
    function ObjectType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ObjectType.GetAll = function () {
        var all = [ObjectType.Article, ObjectType.Asset, ObjectType.Tag, ObjectType.Text, ObjectType.Deliverable];
        return all;
    };
    ObjectType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ObjectType.Article = new ObjectType("Article", "Article");
    ObjectType.Asset = new ObjectType("Asset", "Asset");
    ObjectType.Tag = new ObjectType("Tag", "Tag");
    ObjectType.Text = new ObjectType("Text", "Text");
    ObjectType.Deliverable = new ObjectType("Deliverable", "Deliverable");
    ObjectType.Unknown = new ObjectType("Unknown Object Type", "Unknown ObjectType");
    return ObjectType;
}(EnumBase));
exports.ObjectType = ObjectType;
var OptionalityType = /** @class */ (function (_super) {
    __extends(OptionalityType, _super);
    function OptionalityType(name, id) {
        return _super.call(this, name, id) || this;
    }
    OptionalityType.GetAll = function () {
        var all = [OptionalityType.Required, OptionalityType.Optional];
        return all;
    };
    OptionalityType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OptionalityType.Required = new OptionalityType("Required", "Required");
    OptionalityType.Optional = new OptionalityType("Optional", "Optional");
    OptionalityType.Unknown = new OptionalityType("Unknown Optionality Type ", "UnknownOptionalityType ");
    return OptionalityType;
}(EnumBase));
exports.OptionalityType = OptionalityType;
var OwnerCriteriaOption = /** @class */ (function (_super) {
    __extends(OwnerCriteriaOption, _super);
    function OwnerCriteriaOption(name, id) {
        return _super.call(this, name, id) || this;
    }
    OwnerCriteriaOption.GetAll = function () {
        var all = [OwnerCriteriaOption.DirectOwner, OwnerCriteriaOption.DirectTeam, OwnerCriteriaOption.DirectOwnerOrTeam, OwnerCriteriaOption.AnyAncestor];
        return all;
    };
    OwnerCriteriaOption.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OwnerCriteriaOption.DirectOwner = new OwnerCriteriaOption("Direct Owner", "DirectOwner");
    OwnerCriteriaOption.DirectTeam = new OwnerCriteriaOption("Direct Team", "DirectTeam");
    OwnerCriteriaOption.DirectOwnerOrTeam = new OwnerCriteriaOption("Direct Owner Or Team", "DirectOwnerOrTeam");
    OwnerCriteriaOption.AnyAncestor = new OwnerCriteriaOption("AnyAncestor", "AnyAncestor");
    OwnerCriteriaOption.Unknown = new OwnerCriteriaOption("Unknown Owner Criteria Type", "UnknownOwnerCriteriaType");
    return OwnerCriteriaOption;
}(EnumBase));
exports.OwnerCriteriaOption = OwnerCriteriaOption;
var OwnerType = /** @class */ (function (_super) {
    __extends(OwnerType, _super);
    function OwnerType(name, id) {
        return _super.call(this, name, id) || this;
    }
    OwnerType.GetAll = function () {
        var all = [OwnerType.Person, OwnerType.Team, OwnerType.Role];
        return all;
    };
    OwnerType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OwnerType.Person = new OwnerType("Person", "Person");
    OwnerType.Team = new OwnerType("Team", "Team");
    OwnerType.Role = new OwnerType("Role", "Role");
    OwnerType.Unknown = new OwnerType("Unknown Owner Type ", "UnknownOwnerype ");
    return OwnerType;
}(EnumBase));
exports.OwnerType = OwnerType;
var ParentCriteriaOption = /** @class */ (function (_super) {
    __extends(ParentCriteriaOption, _super);
    function ParentCriteriaOption(name, id) {
        return _super.call(this, name, id) || this;
    }
    ParentCriteriaOption.GetAll = function () {
        var all = [ParentCriteriaOption.DirectParentDeliverable, ParentCriteriaOption.DirectParentPhase, ParentCriteriaOption.AnyAncestorParentDeliverable];
        return all;
    };
    ParentCriteriaOption.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ParentCriteriaOption.DirectParentDeliverable = new ParentCriteriaOption("Direct Parent Deliverable", "DirectParentDeliverable");
    ParentCriteriaOption.DirectParentPhase = new ParentCriteriaOption("Direct Parent Deliverable", "DirectParentPhase");
    ParentCriteriaOption.AnyAncestorParentDeliverable = new ParentCriteriaOption("Any Ancestor Parent Deliverable", "AnyAncestorParentDeliverable");
    ParentCriteriaOption.Unknown = new ParentCriteriaOption("Unknown Parent Criteria Type", "UnknownParentCriteriaType");
    return ParentCriteriaOption;
}(EnumBase));
exports.ParentCriteriaOption = ParentCriteriaOption;
var PhaseFeature = /** @class */ (function (_super) {
    __extends(PhaseFeature, _super);
    function PhaseFeature(name, id) {
        return _super.call(this, name, id) || this;
    }
    PhaseFeature.GetAll = function () {
        var all = [PhaseFeature.Product, PhaseFeature.WorkType, PhaseFeature.Placeholders, PhaseFeature.ReadOnly, PhaseFeature.Editable, PhaseFeature.Dependent, PhaseFeature.Depender, PhaseFeature.SubProduct];
        return all;
    };
    PhaseFeature.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    PhaseFeature.Product = new PhaseFeature("Product", "Product");
    PhaseFeature.WorkType = new PhaseFeature("WorkType", "WorkType");
    PhaseFeature.Placeholders = new PhaseFeature("Placeholders", "Placeholders");
    PhaseFeature.ReadOnly = new PhaseFeature("ReadOnly", "ReadOnly");
    PhaseFeature.Editable = new PhaseFeature("Editable", "Editable");
    PhaseFeature.Dependent = new PhaseFeature("Dependent", "Dependent");
    PhaseFeature.Depender = new PhaseFeature("Depender", "Depender");
    PhaseFeature.SubProduct = new PhaseFeature("SubProduct", "SubProduct");
    PhaseFeature.Unknown = new PhaseFeature("Unknown Deliverable Feature", "UnknownDeliverableFeature");
    return PhaseFeature;
}(EnumBase));
exports.PhaseFeature = PhaseFeature;
var PhaseInstantiationType = /** @class */ (function (_super) {
    __extends(PhaseInstantiationType, _super);
    function PhaseInstantiationType(name, id) {
        return _super.call(this, name, id) || this;
    }
    PhaseInstantiationType.GetAll = function () {
        var all = [PhaseInstantiationType.CreateActive, PhaseInstantiationType.CreateToBeScheduledActionable, PhaseInstantiationType.CreateToBeScheduledHold, PhaseInstantiationType.RemainPending, PhaseInstantiationType.CreateSingleDefaultInstance, PhaseInstantiationType.InstancePerVariantVariableEntry];
        return all;
    };
    PhaseInstantiationType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    PhaseInstantiationType.CreateActive = new PhaseInstantiationType("Create Active", "CreateActive");
    PhaseInstantiationType.CreateToBeScheduledActionable = new PhaseInstantiationType("Create To Be Scheduled Actionable", "CreateToBeScheduledActionable");
    PhaseInstantiationType.CreateToBeScheduledHold = new PhaseInstantiationType("Create To Be Scheduled Hold", "CreateToBeScheduledHold");
    PhaseInstantiationType.RemainPending = new PhaseInstantiationType("Remain Pending", "RemainPending");
    PhaseInstantiationType.CreateSingleDefaultInstance = new PhaseInstantiationType("Create Single Default Instance", "CreateSingleDefaultInstance");
    PhaseInstantiationType.InstancePerVariantVariableEntry = new PhaseInstantiationType("Instance Per Variant Variable Entry", "InstancePerVariantVariableEntry");
    return PhaseInstantiationType;
}(EnumBase));
exports.PhaseInstantiationType = PhaseInstantiationType;
var PhaseType = /** @class */ (function (_super) {
    __extends(PhaseType, _super);
    function PhaseType(name, id) {
        return _super.call(this, name, id) || this;
    }
    PhaseType.GetAll = function () {
        var all = [PhaseType.ProductLineProductHead, PhaseType.ProductLineWorkTypeHead, PhaseType.ContractLineUnAssignedWork, PhaseType.ProductLineProduct,
            PhaseType.ProductLineWorkType, PhaseType.ProductLineUnAssignedWork, PhaseType.ProductLineProductHeadReadOnly, PhaseType.ProductLineWorkTypeHeadReadOnly,
            PhaseType.ContractLineUnAssignedWorkReadOnly, PhaseType.ProductLineProductReadOnly, PhaseType.ProductLineWorkTypeReadOnly, PhaseType.ProductLineUnAssignedWorkReadOnly];
        return all;
    };
    PhaseType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    PhaseType.ProductLineProductHead = new PhaseType("ProductLine Product Head", "ProductLineProductHead");
    PhaseType.ProductLineWorkTypeHead = new PhaseType("ProductLine WorkType Head", "ProductLineWorkTypeHead");
    PhaseType.ContractLineUnAssignedWork = new PhaseType("ContractLine UnAssignedWork", "ContractLineUnAssignedWork");
    PhaseType.ProductLineProduct = new PhaseType("ProductLine Product", "ProductLineProduct");
    PhaseType.ProductLineWorkType = new PhaseType("ProductLine WorkType", "ProductLineWorkType");
    PhaseType.ProductLineUnAssignedWork = new PhaseType("ProductLine UnAssignedWork", "ProductLineUnAssignedWork");
    PhaseType.ProductLineProductHeadReadOnly = new PhaseType("ProductLine ProductHead ReadOnly", "ProductLineProductHeadReadOnly");
    PhaseType.ProductLineWorkTypeHeadReadOnly = new PhaseType("ProductLine WorkTypeHead ReadOnly", "ProductLineWorkTypeHeadReadOnly");
    PhaseType.ContractLineUnAssignedWorkReadOnly = new PhaseType("ContractLine UnAssignedWork ReadOnly", "ContractLineUnAssignedWorkReadOnly");
    PhaseType.ProductLineProductReadOnly = new PhaseType("ProductLine Product ReadOnly", "ProductLineProductReadOnly");
    PhaseType.ProductLineWorkTypeReadOnly = new PhaseType("ProductLine WorkType ReadOnly", "ProductLineWorkTypeReadOnly");
    PhaseType.ProductLineUnAssignedWorkReadOnly = new PhaseType("ProductLine UnAssignedWork ReadOnly", "ProductLineUnAssignedWorkReadOnly");
    PhaseType.Unknown = new PhaseType("Unknown Phase Type", "UnknownPhaseType");
    return PhaseType;
}(EnumBase));
exports.PhaseType = PhaseType;
var PointInTimeType = /** @class */ (function (_super) {
    __extends(PointInTimeType, _super);
    function PointInTimeType(name, id) {
        return _super.call(this, name, id) || this;
    }
    PointInTimeType.GetAll = function () {
        var all = [PointInTimeType.VariableProportion, PointInTimeType.MinutesFromStart, PointInTimeType.MinutesFromEnd, PointInTimeType.OtherPointInTime, PointInTimeType.MinutesFromOppositePointInTime];
        return all;
    };
    PointInTimeType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    PointInTimeType.VariableProportion = new PointInTimeType("Variable Proportion", "VariableProportion");
    PointInTimeType.MinutesFromStart = new PointInTimeType("Minutes from Start", "MinutesFromStart");
    PointInTimeType.MinutesFromEnd = new PointInTimeType("Minutes from End", "MinutesFromEnd");
    PointInTimeType.OtherPointInTime = new PointInTimeType("Other PointInTime", "OtherPointInTime");
    PointInTimeType.MinutesFromOppositePointInTime = new PointInTimeType("Minutes from opposite PointinTime", "MinutesFromOppositePointInTime");
    PointInTimeType.Unknown = new PointInTimeType("Unknown PointInTime Type", "UnknownPointInTimeType");
    return PointInTimeType;
}(EnumBase));
exports.PointInTimeType = PointInTimeType;
var ProductRuleType = /** @class */ (function (_super) {
    __extends(ProductRuleType, _super);
    function ProductRuleType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductRuleType.GetAll = function () {
        var all = [ProductRuleType.Automatic, ProductRuleType.Manual];
        return all;
    };
    ProductRuleType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductRuleType.Automatic = new ProductRuleType("Automatic", "Automatic");
    ProductRuleType.Manual = new ProductRuleType("Manual", "Manual");
    ProductRuleType.Unknown = new ProductRuleType("Unknown ProductRuleType ", "Unknown ProductRuleType ");
    return ProductRuleType;
}(EnumBase));
exports.ProductRuleType = ProductRuleType;
var ProductType = /** @class */ (function (_super) {
    __extends(ProductType, _super);
    function ProductType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductType.GetAll = function () {
        var all = [ProductType.ProductHead, ProductType.ProductChild];
        return all;
    };
    ProductType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductType.ProductHead = new ProductType("Product Head", "ProductHead");
    ProductType.ProductChild = new ProductType("Product Child", "ProductChild");
    ProductType.Unknown = new ProductType("Unknown Product Type", "UnknownProductType");
    return ProductType;
}(EnumBase));
exports.ProductType = ProductType;
var ProductVersionType = /** @class */ (function (_super) {
    __extends(ProductVersionType, _super);
    function ProductVersionType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductVersionType.GetAll = function () {
        var all = [ProductVersionType.Current, ProductVersionType.Previous];
        return all;
    };
    ProductVersionType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductVersionType.Current = new ProductVersionType("Current", "Current");
    ProductVersionType.Previous = new ProductVersionType("Previous", "Previous");
    ProductVersionType.Unknown = new ProductVersionType("Unknown ProductVersionType ", "Unknown ProductVersionType ");
    return ProductVersionType;
}(EnumBase));
exports.ProductVersionType = ProductVersionType;
var ProfileAvailabilityDayStatus = /** @class */ (function (_super) {
    __extends(ProfileAvailabilityDayStatus, _super);
    function ProfileAvailabilityDayStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProfileAvailabilityDayStatus.GetAll = function () {
        var all = [ProfileAvailabilityDayStatus.Working, ProfileAvailabilityDayStatus.PTO, ProfileAvailabilityDayStatus.NationalHoliday, ProfileAvailabilityDayStatus.Weekend];
        return all;
    };
    ProfileAvailabilityDayStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProfileAvailabilityDayStatus.Working = new ProfileAvailabilityDayStatus("Working", "Working");
    ProfileAvailabilityDayStatus.PTO = new ProfileAvailabilityDayStatus("PTO", "PTO");
    ProfileAvailabilityDayStatus.NationalHoliday = new ProfileAvailabilityDayStatus("NationalHoliday", "NationalHoliday");
    ProfileAvailabilityDayStatus.Weekend = new ProfileAvailabilityDayStatus("Weekend", "Weekend");
    ProfileAvailabilityDayStatus.Unknown = new ProfileAvailabilityDayStatus("Unknown Profile Availability Day Status", "UnknownProfileAvailabilityDayStatus");
    return ProfileAvailabilityDayStatus;
}(EnumBase));
exports.ProfileAvailabilityDayStatus = ProfileAvailabilityDayStatus;
var WorkReadyStatus = /** @class */ (function (_super) {
    __extends(WorkReadyStatus, _super);
    function WorkReadyStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    WorkReadyStatus.GetAll = function () {
        var all = [WorkReadyStatus.ReadyToWorkOn, WorkReadyStatus.BeingWorkedOn, WorkReadyStatus.Completed, WorkReadyStatus.Waiting, WorkReadyStatus.Provisional, WorkReadyStatus.Cancelled, WorkReadyStatus.OnHold, WorkReadyStatus.PendingReady, WorkReadyStatus.PendingWaiting, WorkReadyStatus.Schedule, WorkReadyStatus.ScheduleWaiting, WorkReadyStatus.ScheduleHoldWaiting, WorkReadyStatus.ScheduleHoldReady];
        return all;
    };
    WorkReadyStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    WorkReadyStatus.ReadyToWorkOn = new WorkReadyStatus("Ready To Work On", "ReadyToWorkOn");
    WorkReadyStatus.BeingWorkedOn = new WorkReadyStatus("Being Worked On", "BeingWorkedOn");
    WorkReadyStatus.Completed = new WorkReadyStatus("Completed", "Completed");
    WorkReadyStatus.Waiting = new WorkReadyStatus("Waiting", "Waiting");
    WorkReadyStatus.Provisional = new WorkReadyStatus("Provisional", "Provisional");
    WorkReadyStatus.Cancelled = new WorkReadyStatus("Cancelled", "Cancelled");
    WorkReadyStatus.OnHold = new WorkReadyStatus("On Hold", "OnHold");
    WorkReadyStatus.PendingReady = new WorkReadyStatus("Pending Ready", "PendingReady");
    WorkReadyStatus.PendingWaiting = new WorkReadyStatus("Pending Waiting", "PendingWaiting");
    WorkReadyStatus.Schedule = new WorkReadyStatus("Schedule", "Schedule");
    WorkReadyStatus.ScheduleWaiting = new WorkReadyStatus("Schedule Waiting", "ScheduleWaiting");
    WorkReadyStatus.ScheduleHoldWaiting = new WorkReadyStatus("Schedule Hold", "ScheduleHold");
    WorkReadyStatus.ScheduleHoldReady = new WorkReadyStatus("Schedule Hold Ready", "ScheduleHoldReady");
    WorkReadyStatus.Unknown = new WorkReadyStatus("Unknown Work Ready Status Type", "UnknownWorkReadyStatusType");
    return WorkReadyStatus;
}(EnumBase));
exports.WorkReadyStatus = WorkReadyStatus;
var UnitType = /** @class */ (function (_super) {
    __extends(UnitType, _super);
    function UnitType(name, id, minutesPerUnit) {
        var _this = _super.call(this, name, id) || this;
        _this.minutesPerUnit = minutesPerUnit;
        return _this;
    }
    UnitType.GetAll = function () {
        var all = [UnitType.SparkResponsive, UnitType.CoreSmb];
        return all;
    };
    UnitType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    UnitType.SparkResponsive = new UnitType("Spark Responsive", "SparkResponsive", 30);
    UnitType.CoreSmb = new UnitType("Core Smb", "CoreSmb", 37.5);
    UnitType.Unknown = new UnitType("Unknown Unit Type", "UnknownUnitType", -1);
    return UnitType;
}(EnumBase));
exports.UnitType = UnitType;
var MonthlyUnitsSubgroupType = /** @class */ (function (_super) {
    __extends(MonthlyUnitsSubgroupType, _super);
    function MonthlyUnitsSubgroupType(name, id) {
        return _super.call(this, name, id) || this;
    }
    MonthlyUnitsSubgroupType.GetAll = function () {
        var all = [MonthlyUnitsSubgroupType.NoSubgroup, MonthlyUnitsSubgroupType.ContractType, MonthlyUnitsSubgroupType.Department, MonthlyUnitsSubgroupType.Feed, MonthlyUnitsSubgroupType.WorkStatus, MonthlyUnitsSubgroupType.ProductClass, MonthlyUnitsSubgroupType.WorkOwner, MonthlyUnitsSubgroupType.ContractOwner, MonthlyUnitsSubgroupType.ContractOwnerAndDepartment, MonthlyUnitsSubgroupType.WorkType];
        return all;
    };
    MonthlyUnitsSubgroupType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    MonthlyUnitsSubgroupType.NoSubgroup = new MonthlyUnitsSubgroupType("None", "None");
    MonthlyUnitsSubgroupType.ContractType = new MonthlyUnitsSubgroupType("Contract Type", "ContractType");
    MonthlyUnitsSubgroupType.Department = new MonthlyUnitsSubgroupType("Department", "Department");
    MonthlyUnitsSubgroupType.Feed = new MonthlyUnitsSubgroupType("Feed", "Feed");
    MonthlyUnitsSubgroupType.WorkStatus = new MonthlyUnitsSubgroupType("Work Ready Status", "WorkStatus");
    MonthlyUnitsSubgroupType.ProductClass = new MonthlyUnitsSubgroupType("Product Class", "ProductClass");
    MonthlyUnitsSubgroupType.WorkOwner = new MonthlyUnitsSubgroupType("Work Owner", "WorkOwner");
    MonthlyUnitsSubgroupType.ContractOwner = new MonthlyUnitsSubgroupType("Contract Owner", "ContractOwner");
    MonthlyUnitsSubgroupType.ContractOwnerAndDepartment = new MonthlyUnitsSubgroupType("Contract Owner And Department", "ContractOwnerAndDepartment");
    MonthlyUnitsSubgroupType.WorkType = new MonthlyUnitsSubgroupType("WorkType", "WorkType");
    return MonthlyUnitsSubgroupType;
}(EnumBase));
exports.MonthlyUnitsSubgroupType = MonthlyUnitsSubgroupType;
var TermType = /** @class */ (function (_super) {
    __extends(TermType, _super);
    function TermType(name, id) {
        return _super.call(this, name, id) || this;
    }
    TermType.GetAll = function () {
        var all = [TermType.ManualTerm, TermType.AutomaticTerm];
        return all;
    };
    TermType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    TermType.ManualTerm = new TermType("Manual Term", "ManualTerm");
    TermType.AutomaticTerm = new TermType("Automatic Term", "AutomaticTerm");
    TermType.Unknown = new TermType("Unknown Instance Type", "UnknownTermType");
    return TermType;
}(EnumBase));
exports.TermType = TermType;
var UnitRuleOperatorType = /** @class */ (function (_super) {
    __extends(UnitRuleOperatorType, _super);
    function UnitRuleOperatorType(name, id) {
        return _super.call(this, name, id) || this;
    }
    UnitRuleOperatorType.GetAll = function () {
        var all = [UnitRuleOperatorType.Fixed, UnitRuleOperatorType.InBetweenRange, UnitRuleOperatorType.Minimum, UnitRuleOperatorType.Maximum, UnitRuleOperatorType.MultipleOf];
        return all;
    };
    UnitRuleOperatorType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    UnitRuleOperatorType.Fixed = new UnitRuleOperatorType("Fixed", "Fixed");
    UnitRuleOperatorType.InBetweenRange = new UnitRuleOperatorType("In Between RangeValues", "InBetweenRange");
    UnitRuleOperatorType.Minimum = new UnitRuleOperatorType("Minimum", "Minimum");
    UnitRuleOperatorType.Maximum = new UnitRuleOperatorType("Maximum", "Maximum");
    UnitRuleOperatorType.MultipleOf = new UnitRuleOperatorType("Multiple Of", "MultipleOf");
    UnitRuleOperatorType.Unknown = new UnitRuleOperatorType("Unknown Operator Type ", "UnknownOperatorType ");
    return UnitRuleOperatorType;
}(EnumBase));
exports.UnitRuleOperatorType = UnitRuleOperatorType;
var UnitSpreadType = /** @class */ (function (_super) {
    __extends(UnitSpreadType, _super);
    function UnitSpreadType(name, id, rank) {
        var _this = _super.call(this, name, id) || this;
        _this.rank = rank;
        return _this;
    }
    UnitSpreadType.GetAll = function () {
        var all = [UnitSpreadType.VariableProportion, UnitSpreadType.FixedProportion, UnitSpreadType.FixedAndVariableProportion];
        return all;
    };
    UnitSpreadType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    UnitSpreadType.FixedAndVariableProportion = new UnitSpreadType("Fixed And Variable Proportion", "FixedAndVariableProportion", 3);
    UnitSpreadType.VariableProportion = new UnitSpreadType("Variable Proportion", "VariableProportion", 2);
    UnitSpreadType.FixedProportion = new UnitSpreadType("Fixed Proportion", "FixedProportion", 1);
    UnitSpreadType.Unknown = new UnitSpreadType("Unknown UnitSpread Type", "UnknownUnitSpreadType", -1);
    return UnitSpreadType;
}(EnumBase));
exports.UnitSpreadType = UnitSpreadType;
var WorkTimeliness = /** @class */ (function (_super) {
    __extends(WorkTimeliness, _super);
    function WorkTimeliness(name, id) {
        return _super.call(this, name, id) || this;
    }
    WorkTimeliness.GetAll = function () {
        var all = [WorkTimeliness.OnSchedule, WorkTimeliness.Overdue, WorkTimeliness.AheadOfSchedule, WorkTimeliness.UpSoon];
        return all;
    };
    WorkTimeliness.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    WorkTimeliness.OnSchedule = new WorkTimeliness("On Schedule", "OnSchedule");
    WorkTimeliness.Overdue = new WorkTimeliness("Overdue", "Overdue");
    WorkTimeliness.AheadOfSchedule = new WorkTimeliness("Ahead Of Schedule", "AheadOfSchedule");
    WorkTimeliness.UpSoon = new WorkTimeliness("Up Soon", "UpSoon");
    WorkTimeliness.Unknown = new WorkTimeliness("Unknown Work Timeliness Type", "UnknownWorkTimelinessType");
    return WorkTimeliness;
}(EnumBase));
exports.WorkTimeliness = WorkTimeliness;
var OrderByCriteria = /** @class */ (function (_super) {
    __extends(OrderByCriteria, _super);
    function OrderByCriteria(name, id) {
        return _super.call(this, name, id) || this;
    }
    OrderByCriteria.GetAll = function () {
        var all = [OrderByCriteria.NameAscending, OrderByCriteria.NameDescending, OrderByCriteria.CreatedAscending, OrderByCriteria.CreatedDescending, OrderByCriteria.LastModifiedAscending, OrderByCriteria.LastModifiedDescending, OrderByCriteria.StartDateAscending, OrderByCriteria.StartDateDescending, OrderByCriteria.EndDateAscending, OrderByCriteria.EndDateDescending,
            OrderByCriteria.FeedNameAscending, OrderByCriteria.FeedNameDescending, OrderByCriteria.WorkReadyStatusAscending, OrderByCriteria.WorkReadyStatusDescending, OrderByCriteria.OwnerAscending, OrderByCriteria.OwnerDescending, OrderByCriteria.ModuleAscending, OrderByCriteria.ModuleDescending, OrderByCriteria.ModuleAscending, OrderByCriteria.ModuleDescending, OrderByCriteria.HeadNameAscending, OrderByCriteria.HeadNameDescending,
            OrderByCriteria.CompletedPaceAscending, OrderByCriteria.CompletedPaceAscending, OrderByCriteria.TargetDateAscending, OrderByCriteria.TargetDateDescending];
        return all;
    };
    OrderByCriteria.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OrderByCriteria.NameAscending = new OrderByCriteria("Name Ascending", "NameAscending");
    OrderByCriteria.NameDescending = new OrderByCriteria("Name Descending", "NameDescending");
    OrderByCriteria.CreatedAscending = new OrderByCriteria("Created Ascending", "CreatedAscending");
    OrderByCriteria.CreatedDescending = new OrderByCriteria("Created Descending", "CreatedDescending");
    OrderByCriteria.LastModifiedAscending = new OrderByCriteria("LastModified Ascending", "LastModifiedAscending");
    OrderByCriteria.LastModifiedDescending = new OrderByCriteria("LastModified Descending", "LastModifiedDescending");
    OrderByCriteria.StartDateAscending = new OrderByCriteria("StartDate Ascending", "StartDateAscending");
    OrderByCriteria.StartDateDescending = new OrderByCriteria("StartDate Descending", "StartDateDescending");
    OrderByCriteria.EndDateAscending = new OrderByCriteria("EndDate Ascending", "EndDateAscending");
    OrderByCriteria.EndDateDescending = new OrderByCriteria("EndDate Descending", "EndDateDescending");
    OrderByCriteria.FeedNameAscending = new OrderByCriteria("Feed Name Ascending", "FeedNameAscending");
    OrderByCriteria.FeedNameDescending = new OrderByCriteria("Feed Name Descending", "FeedNameDescending");
    OrderByCriteria.WorkReadyStatusAscending = new OrderByCriteria("Work Ready Status Ascending", "WorkReadyStatusAscending");
    OrderByCriteria.WorkReadyStatusDescending = new OrderByCriteria("Work Ready Status Descending", "WorkReadyStatusDescending");
    OrderByCriteria.OwnerAscending = new OrderByCriteria("Owner Ascending", "OwnerAscending");
    OrderByCriteria.OwnerDescending = new OrderByCriteria("Owner Descending", "OwnerDescending");
    OrderByCriteria.ModuleAscending = new OrderByCriteria("Module Ascending", "ModuleAscending");
    OrderByCriteria.ModuleDescending = new OrderByCriteria("Module Descending", "ModuleDescending");
    OrderByCriteria.HeadNameAscending = new OrderByCriteria("Head Name Ascending", "HeadNameAscending");
    OrderByCriteria.HeadNameDescending = new OrderByCriteria("Head Name Descending", "HeadNameDescending");
    OrderByCriteria.CompletedPaceAscending = new OrderByCriteria("Completed Pace Ascending", "CompletedPaceAscending");
    OrderByCriteria.CompletedPaceDescending = new OrderByCriteria("Completed Pace Descending", "CompletedPaceDescending");
    OrderByCriteria.TargetDateAscending = new OrderByCriteria("Target Date Ascending", "TargetDateAscending");
    OrderByCriteria.TargetDateDescending = new OrderByCriteria("Target Date Descending", "TargetDateDescending");
    OrderByCriteria.Unknown = new OrderByCriteria("Unknown OrderBy Criteria", "UnknownOrderByCriteria");
    return OrderByCriteria;
}(EnumBase));
exports.OrderByCriteria = OrderByCriteria;
var SelectCriteriaObjectType = /** @class */ (function (_super) {
    __extends(SelectCriteriaObjectType, _super);
    function SelectCriteriaObjectType(name, id) {
        return _super.call(this, name, id) || this;
    }
    SelectCriteriaObjectType.GetAll = function () {
        var all = [SelectCriteriaObjectType.StubObject, SelectCriteriaObjectType.FullObject];
        return all;
    };
    SelectCriteriaObjectType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SelectCriteriaObjectType.StubObject = new SelectCriteriaObjectType("Stub Object", "StubObject");
    SelectCriteriaObjectType.FullObject = new SelectCriteriaObjectType("Full Object", "FullObject");
    SelectCriteriaObjectType.Unknown = new SelectCriteriaObjectType("Unknown Select Criteria Object Type ", "SelectCriteriaObjectType");
    return SelectCriteriaObjectType;
}(EnumBase));
exports.SelectCriteriaObjectType = SelectCriteriaObjectType;
var SelectCriteriaField = /** @class */ (function (_super) {
    __extends(SelectCriteriaField, _super);
    function SelectCriteriaField(name, id, dataType) {
        var _this = _super.call(this, name, id) || this;
        _this.dataType = dataType;
        return _this;
    }
    SelectCriteriaField.GetAll = function () {
        var all = [SelectCriteriaField.SelectCoreFields, SelectCriteriaField.SelectUnitsTotal, SelectCriteriaField.SelectRangeTotal, SelectCriteriaField.SelectProductDefinitions, SelectCriteriaField.SelectProductInstances, SelectCriteriaField.SelectWorkTypes, SelectCriteriaField.SelectAggregateUnitsTotal, SelectCriteriaField.SelectAggregateRangeTotal];
        return all;
    };
    SelectCriteriaField.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SelectCriteriaField.SelectCoreFields = new SelectCriteriaField("Select Core Fields", "SelectCoreFields", typeof (false));
    SelectCriteriaField.SelectUnitsTotal = new SelectCriteriaField("Select Units Total", "SelectUnitsTotal", typeof (false));
    SelectCriteriaField.SelectRangeTotal = new SelectCriteriaField("Select Range Total", "SelectRangeTotal", typeof (false));
    SelectCriteriaField.SelectProductDefinitions = new SelectCriteriaField("Select Product Definitions", "SelectProductDefinitions", typeof (SelectCriteriaObjectType.Unknown));
    SelectCriteriaField.SelectProductInstances = new SelectCriteriaField("Select Product Instances", "SelectProductInstances", typeof (SelectCriteriaObjectType.Unknown));
    SelectCriteriaField.SelectWorkTypes = new SelectCriteriaField("Select Work Types", "SelectWorkTypes", typeof (false));
    SelectCriteriaField.SelectAggregateUnitsTotal = new SelectCriteriaField("Select Aggregate Units Total", "SelectAggregateUnitsTotal", typeof (false));
    SelectCriteriaField.SelectAggregateRangeTotal = new SelectCriteriaField("Select Aggregate Range Total", "SelectAggregateRangeTotal", typeof (false));
    return SelectCriteriaField;
}(EnumBase));
exports.SelectCriteriaField = SelectCriteriaField;
var DeliverableModule = /** @class */ (function (_super) {
    __extends(DeliverableModule, _super);
    function DeliverableModule(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliverableModule.GetAll = function () {
        return [this.Base, this.Contract, this.Video, this.Editorial, this.Design, this.Social, this.Consulting, this.Tech, this.AccountManagement, this.Organization, this.Idea, this.Campaign, this.Content, this.Production, this.Publish, this.MasterProject];
    };
    DeliverableModule.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliverableModule.Base = new DeliverableModule("Base", "Base");
    DeliverableModule.Contract = new DeliverableModule("Contract", "Contract");
    DeliverableModule.Video = new DeliverableModule("Video", "Video");
    DeliverableModule.Editorial = new DeliverableModule("Editorial", "Editorial");
    DeliverableModule.Design = new DeliverableModule("Design", "Design");
    DeliverableModule.Social = new DeliverableModule("Social", "Social");
    DeliverableModule.Consulting = new DeliverableModule("Consulting", "Consulting");
    DeliverableModule.Tech = new DeliverableModule("Tech", "Tech");
    DeliverableModule.AccountManagement = new DeliverableModule("Account Management", "AccountManagement");
    DeliverableModule.Organization = new DeliverableModule("Organization", "Organization");
    DeliverableModule.Idea = new DeliverableModule("Idea", "Idea");
    DeliverableModule.Campaign = new DeliverableModule("Campaign", "Campaign");
    DeliverableModule.Content = new DeliverableModule("Content", "Content");
    DeliverableModule.Production = new DeliverableModule("Production", "Production");
    DeliverableModule.Publish = new DeliverableModule("Publish", "Publish");
    DeliverableModule.MasterProject = new DeliverableModule("Master Project", "MasterProject");
    DeliverableModule.Unknown = new DeliverableModule("Unknown", "Unknown");
    return DeliverableModule;
}(EnumBase));
exports.DeliverableModule = DeliverableModule;
var SearchableField = /** @class */ (function (_super) {
    __extends(SearchableField, _super);
    function SearchableField(name, id, criteriaType, criteriaCollection, dataType) {
        var _this = _super.call(this, name, id) || this;
        _this.criteriaType = criteriaType;
        _this.criteriaCollection = criteriaCollection;
        _this.dataType = dataType;
        return _this;
    }
    SearchableField.GetAll = function () {
        var all = [SearchableField.DeliverableId, SearchableField.Contract, SearchableField.StartDateTo, SearchableField.StartDateFrom, SearchableField.EndDateTo, SearchableField.EndDateFrom, SearchableField.ProductInstance, SearchableField.ProductDefinition, SearchableField.AssignableType, SearchableField.WorkTypeDefaultOwner, SearchableField.ProductDefinitionDefaultOwner, SearchableField.PhaseDefinitionDefaultOwner, SearchableField.WorkReadyStatus, SearchableField.OutcomeType, SearchableField.OutcomeName, SearchableField.UnitType, SearchableField.ProductAllocationOwner, SearchableField.Owner, SearchableField.Parent];
        return all;
    };
    SearchableField.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SearchableField.DeliverableId = new SearchableField("Deliverable Id", "DeliverableId", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.Contract = new SearchableField("Contract", "Contract", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.StartDateTo = new SearchableField("Start Date To", "StartDateTo", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (new Date()));
    SearchableField.StartDateFrom = new SearchableField("Start Date From", "StartDateFrom", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (new Date()));
    SearchableField.EndDateTo = new SearchableField("End Date To", "EndDateTo", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (new Date()));
    SearchableField.EndDateFrom = new SearchableField("End Date From", "EndDateFrom", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (new Date()));
    SearchableField.ProductInstance = new SearchableField("Product Instance", "ProductInstance", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.ProductDefinition = new SearchableField("Product Definition", "ProductDefinition", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.AssignableType = new SearchableField("Assignable Type", "AssignableType", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (AssignableProductType.Unknown));
    SearchableField.WorkTypeDefaultOwner = new SearchableField("WorkType Default Owner", "WorkTypeDefaultOwner", CriteriaType.OwnerCriteria, CriteriaCollection.WorkTypes, typeof (0));
    SearchableField.ProductDefinitionDefaultOwner = new SearchableField("Product Definition Default Owner", "ProductDefinitionDefaultOwner", CriteriaType.OwnerCriteria, CriteriaCollection.ProductDefinitions, typeof (0));
    SearchableField.PhaseDefinitionDefaultOwner = new SearchableField("Phase Definition Default Owner", "PhaseDefinitionDefaultOwner", CriteriaType.OwnerCriteria, CriteriaCollection.ProductDefinitions, typeof (0));
    SearchableField.ProductInstanceDefaultOwner = new SearchableField("Product Instance Default Owner", "ProductInstanceDefaultOwner", CriteriaType.OwnerCriteria, CriteriaCollection.ProductInstances, typeof (0));
    SearchableField.PhaseInstanceDefaultOwner = new SearchableField("Phase Instance Default Owner", "PhaseInstanceDefaultOwner ", CriteriaType.OwnerCriteria, CriteriaCollection.ProductInstances, typeof (0));
    SearchableField.WorkReadyStatus = new SearchableField("Work Ready Status", "WorkReadyStatus", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (WorkReadyStatus.Unknown));
    SearchableField.OutcomeType = new SearchableField("Outcome Type", "OutcomeType", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (ObjectType));
    SearchableField.OutcomeName = new SearchableField("Outcome Name", "OutcomeName", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.UnitType = new SearchableField("Unit Type", "UnitType", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (UnitType));
    SearchableField.ProductAllocationOwner = new SearchableField("Product Allocation Owner", "ProductAllocationOwner", CriteriaType.OwnerCriteria, CriteriaCollection.ProductInstances, typeof (0));
    SearchableField.Owner = new SearchableField("Owner", "Owner", CriteriaType.OwnerCriteria, CriteriaCollection.Deliverables, typeof (0));
    SearchableField.OwnerType = new SearchableField("Owner Type", "OwnerType", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (OwnerType.Unknown));
    SearchableField.Parent = new SearchableField("Parent", "Parent", CriteriaType.DeliverableOrPhaseCriteria, CriteriaCollection.Deliverables, typeof (""));
    SearchableField.FeedId = new SearchableField("Feed Id", "FeedId", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (0));
    SearchableField.ExistenceType = new SearchableField("Existence Type", "ExistenceType", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (ExistenceType.Unknown));
    SearchableField.ProductType = new SearchableField("Product Type", "ProductType", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (ProductType.Unknown));
    SearchableField.Module = new SearchableField("Module", "Module", CriteriaType.DirectCriteria, CriteriaCollection.Deliverables, typeof (DeliverableModule.Unknown));
    return SearchableField;
}(EnumBase));
exports.SearchableField = SearchableField;
var SimpleDType = /** @class */ (function (_super) {
    __extends(SimpleDType, _super);
    function SimpleDType(name, id) {
        return _super.call(this, name, id) || this;
    }
    SimpleDType.GetAll = function () {
        var all = [SimpleDType.Project, SimpleDType.PlaceholderProject, SimpleDType.SubProduct, SimpleDType.PlaceholderSubProduct, SimpleDType.Work, SimpleDType.PlaceholderWork, SimpleDType.Multi, SimpleDType.PlaceholderMulti, SimpleDType.UnAssigned];
        return all;
    };
    SimpleDType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SimpleDType.Project = new SimpleDType("Project", "Project");
    SimpleDType.PlaceholderProject = new SimpleDType("Placeholder Project", "PlaceholderProject");
    SimpleDType.SubProduct = new SimpleDType("SubProduct", "SubProduct");
    SimpleDType.PlaceholderSubProduct = new SimpleDType("Placeholder SubProduct", "PlaceholderSubProduct");
    SimpleDType.Work = new SimpleDType("Work", "Work");
    SimpleDType.PlaceholderWork = new SimpleDType("Placeholder Work", "PlaceholderWork");
    SimpleDType.Multi = new SimpleDType("Multi", "Multi");
    SimpleDType.PlaceholderMulti = new SimpleDType("Placeholder Multi", "PlaceholderMulti");
    SimpleDType.UnAssigned = new SimpleDType("UnAssigned", "UnAssigned");
    return SimpleDType;
}(EnumBase));
exports.SimpleDType = SimpleDType;
var TimeUseType = /** @class */ (function (_super) {
    __extends(TimeUseType, _super);
    function TimeUseType(name, id) {
        return _super.call(this, name, id) || this;
    }
    TimeUseType.GetAll = function () {
        var all = [TimeUseType.FullParentRange, TimeUseType.UnitBasedTimeRange, TimeUseType.PercentageParentRange, TimeUseType.MinutesRange, TimeUseType.NoMinimum, TimeUseType.MinutesAndUnitsRange];
        return all;
    };
    TimeUseType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    TimeUseType.FullParentRange = new TimeUseType("Full Parent Range", "FullParentRange");
    TimeUseType.UnitBasedTimeRange = new TimeUseType("Unit Based Time Range", "UnitBasedTimeRange");
    TimeUseType.PercentageParentRange = new TimeUseType("Percentage Parent Range", "PercentageParentRange");
    TimeUseType.MinutesRange = new TimeUseType("Minutes Range", "MinutesRange");
    TimeUseType.MinutesAndUnitsRange = new TimeUseType("Minutes And Units Range", "MinutesAndUnitsRange");
    TimeUseType.NoMinimum = new TimeUseType("No Minimum", "NoMinimum");
    return TimeUseType;
}(EnumBase));
exports.TimeUseType = TimeUseType;
var ToDoType = /** @class */ (function (_super) {
    __extends(ToDoType, _super);
    function ToDoType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ToDoType.GetAll = function () {
        var all = [ToDoType.Contract, ToDoType.Product, ToDoType.Work, ToDoType.UnAssigned, ToDoType.UnStartedProduct, ToDoType.UnStartedWork];
        return all;
    };
    ToDoType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ToDoType.Contract = new ToDoType("Contract", "CON");
    ToDoType.Product = new ToDoType("Product", "PROD");
    ToDoType.Work = new ToDoType("Work", "WORK");
    ToDoType.UnAssigned = new ToDoType("UnAssigned Work", "UNAS");
    ToDoType.UnStartedProduct = new ToDoType("UnStarted Product", "UNST-PRD");
    ToDoType.UnStartedWork = new ToDoType("UnStarted Work", "UNST-WRK");
    return ToDoType;
}(EnumBase));
exports.ToDoType = ToDoType;
var ToDoFeature = /** @class */ (function (_super) {
    __extends(ToDoFeature, _super);
    function ToDoFeature(name, id) {
        return _super.call(this, name, id) || this;
    }
    ToDoFeature.GetAll = function () {
        var all = [ToDoFeature.Product, ToDoFeature.WorkType, ToDoFeature.Outcomes, ToDoFeature.Children, ToDoFeature.Parent, ToDoFeature.Placeholder, ToDoFeature.RealWork];
        return all;
    };
    ToDoFeature.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ToDoFeature.Product = new ToDoFeature("Product", "Product");
    ToDoFeature.WorkType = new ToDoFeature("WorkType", "WorkType");
    ToDoFeature.Outcomes = new ToDoFeature("Outcomes", "Outcomes");
    ToDoFeature.Children = new ToDoFeature("Children", "Children");
    ToDoFeature.Parent = new ToDoFeature("Parent", "Parent");
    ToDoFeature.Placeholder = new ToDoFeature("Placeholder", "Placeholder");
    ToDoFeature.RealWork = new ToDoFeature("Real Work", "RealWork");
    return ToDoFeature;
}(EnumBase));
exports.ToDoFeature = ToDoFeature;
var ActionPriority = /** @class */ (function (_super) {
    __extends(ActionPriority, _super);
    function ActionPriority(name, id) {
        return _super.call(this, name, id) || this;
    }
    ActionPriority.GetAll = function () {
        var all = [ActionPriority.Primary, ActionPriority.Secondary];
        return all;
    };
    ActionPriority.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ActionPriority.Primary = new ActionPriority("Primary", "Primary");
    ActionPriority.Secondary = new ActionPriority("Secondary", "Secondary");
    return ActionPriority;
}(EnumBase));
exports.ActionPriority = ActionPriority;
var VideoType = /** @class */ (function (_super) {
    __extends(VideoType, _super);
    function VideoType(name, id) {
        return _super.call(this, name, id) || this;
    }
    VideoType.GetAll = function () {
        var all = [VideoType.Project, VideoType.SubProduct, VideoType.Work];
        return all;
    };
    VideoType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    VideoType.Project = new VideoType("Project", "Project");
    VideoType.SubProduct = new VideoType("SubProduct", "SubProduct");
    VideoType.Work = new VideoType("Work", "Work");
    VideoType.Pending = new VideoType("Pending", "Pending");
    return VideoType;
}(EnumBase));
exports.VideoType = VideoType;
var ProductClassVariantType = /** @class */ (function (_super) {
    __extends(ProductClassVariantType, _super);
    function ProductClassVariantType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductClassVariantType.GetAll = function () {
        var all = [ProductClassVariantType.Fixed, ProductClassVariantType.Variable];
        return all;
    };
    ProductClassVariantType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductClassVariantType.Fixed = new ProductClassVariantType("Fixed", "Fixed");
    ProductClassVariantType.Variable = new ProductClassVariantType("Variable", "Variable");
    return ProductClassVariantType;
}(EnumBase));
exports.ProductClassVariantType = ProductClassVariantType;
var ScheduleProjectType = /** @class */ (function (_super) {
    __extends(ScheduleProjectType, _super);
    function ScheduleProjectType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ScheduleProjectType.GetAll = function () {
        var all = [ScheduleProjectType.NotScheduled, ScheduleProjectType.StartNow, ScheduleProjectType.StartAt, ScheduleProjectType.DueBy, ScheduleProjectType.ManualAll, ScheduleProjectType.ManualSome, ScheduleProjectType.FullRange, ScheduleProjectType.NextMonth];
        return all;
    };
    ScheduleProjectType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ScheduleProjectType.NotScheduled = new ScheduleProjectType("Not Scheduled", "NotScheduled");
    ScheduleProjectType.StartNow = new ScheduleProjectType("Start Now", "StartNow");
    ScheduleProjectType.StartAt = new ScheduleProjectType("Start At", "StartAt");
    ScheduleProjectType.DueBy = new ScheduleProjectType("Due By", "DueBy");
    ScheduleProjectType.NextMonth = new ScheduleProjectType("Next Month", "NextMonth");
    ScheduleProjectType.ManualAll = new ScheduleProjectType("Manual All", "ManualAll");
    ScheduleProjectType.ManualSome = new ScheduleProjectType("Manual Some", "ManualSome");
    ScheduleProjectType.FullRange = new ScheduleProjectType("Full Range", "FullRange");
    return ScheduleProjectType;
}(EnumBase));
exports.ScheduleProjectType = ScheduleProjectType;
var ToBeScheduledType = /** @class */ (function (_super) {
    __extends(ToBeScheduledType, _super);
    function ToBeScheduledType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ToBeScheduledType.GetAll = function () {
        var all = [ToBeScheduledType.ToBeScheduled, ToBeScheduledType.ToBeScheduledHold];
        return all;
    };
    ToBeScheduledType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ToBeScheduledType.ToBeScheduled = new ToBeScheduledType("To Be Scheduled", "ToBeScheduled");
    ToBeScheduledType.ToBeScheduledHold = new ToBeScheduledType("To Be Scheduled Hold", "ToBeScheduledHold");
    return ToBeScheduledType;
}(EnumBase));
exports.ToBeScheduledType = ToBeScheduledType;
var OutcomeUseType = /** @class */ (function (_super) {
    __extends(OutcomeUseType, _super);
    function OutcomeUseType(name, id) {
        return _super.call(this, name, id) || this;
    }
    OutcomeUseType.GetAll = function () {
        var all = [OutcomeUseType.FinalDeliverable, OutcomeUseType.InterimDeliverable, OutcomeUseType.InternalDocument];
        return all;
    };
    OutcomeUseType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OutcomeUseType.FinalDeliverable = new OutcomeUseType("Final Deliverable", "FinalDeliverable");
    OutcomeUseType.InterimDeliverable = new OutcomeUseType("Interim Deliverable", "InterimDeliverable");
    OutcomeUseType.InternalDocument = new OutcomeUseType("Internal Document", "InternalDocument");
    return OutcomeUseType;
}(EnumBase));
exports.OutcomeUseType = OutcomeUseType;
var GroupByCriteria = /** @class */ (function (_super) {
    __extends(GroupByCriteria, _super);
    function GroupByCriteria(name, id) {
        return _super.call(this, name, id) || this;
    }
    GroupByCriteria.GetAll = function () {
        return [this.Status, this.Feed, this.Month, this.Owner, this.Module];
    };
    GroupByCriteria.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    GroupByCriteria.Status = new GroupByCriteria("Status", "WorkReadyStatus");
    GroupByCriteria.Feed = new GroupByCriteria("Feed", "FeedName");
    GroupByCriteria.Month = new GroupByCriteria("Month", "Month");
    GroupByCriteria.Owner = new GroupByCriteria("Owner", "Owner");
    GroupByCriteria.Module = new GroupByCriteria("Module", "Module");
    return GroupByCriteria;
}(EnumBase));
exports.GroupByCriteria = GroupByCriteria;
var GroupKey = /** @class */ (function (_super) {
    __extends(GroupKey, _super);
    function GroupKey(name, id) {
        return _super.call(this, name, id) || this;
    }
    GroupKey.GetAll = function () {
        var all = [GroupKey.FeedDetails, GroupKey.Owner, GroupKey.Date, GroupKey.Month, GroupKey.ProductName, GroupKey.ContractType, GroupKey.BusinessUnit, GroupKey.UnitType, GroupKey.MonthContractOwner, GroupKey.Contract, GroupKey.ProjectDeliveryMonth];
        return all;
    };
    GroupKey.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    GroupKey.FeedDetails = new GroupKey("Feed Details", "FeedDetails");
    GroupKey.Owner = new GroupKey("Owner", "Owner");
    GroupKey.Date = new GroupKey("Date", "Date");
    GroupKey.Month = new GroupKey("Month", "Month");
    GroupKey.ProductName = new GroupKey("Product Name", "ProductName");
    GroupKey.ContractType = new GroupKey("Contract Type", "ContractType");
    GroupKey.Contract = new GroupKey("Contract", "Contract");
    GroupKey.MonthContractOwner = new GroupKey("Month and Contract Owner", "MonthContractOwner");
    GroupKey.BusinessUnit = new GroupKey("Business Unit", "BusinessUnit");
    GroupKey.UnitType = new GroupKey("Unit Type", "UnitType");
    GroupKey.ProjectDeliveryMonth = new GroupKey("Project Delivery Month", "ProjectDeliveryMonth");
    GroupKey.Unknown = new GroupKey("Unknown Existance Type", "UnknownExistanceType");
    return GroupKey;
}(EnumBase));
exports.GroupKey = GroupKey;
var GroupByCriterion;
(function (GroupByCriterion) {
    GroupByCriterion["Status"] = "WorkReadyStatus";
    GroupByCriterion["Feed"] = "FeedName";
    GroupByCriterion["Month"] = "Month";
    GroupByCriterion["Owner"] = "Owner";
    GroupByCriterion["Module"] = "Module";
    //Product = "Product"
})(GroupByCriterion = exports.GroupByCriterion || (exports.GroupByCriterion = {}));
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["asc"] = "Ascending";
    OrderDirection["desc"] = "Descending";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
var OrderByCriterion;
(function (OrderByCriterion) {
    OrderByCriterion["Name"] = "Name";
    OrderByCriterion["Created"] = "Created";
    OrderByCriterion["LastModified"] = "LastModified";
    OrderByCriterion["StartDate"] = "StartDate";
    OrderByCriterion["EndDate"] = "EndDate";
    OrderByCriterion["FeedName"] = "FeedName";
    OrderByCriterion["WorkReadyStatus"] = "WorkReadyStatus";
    OrderByCriterion["Owner"] = "Owner";
    OrderByCriterion["Module"] = "Module";
    OrderByCriterion["TargetDate"] = "TargetDate";
    //Product = "Product"
})(OrderByCriterion = exports.OrderByCriterion || (exports.OrderByCriterion = {}));
